import { GenericBaseParameter } from '../base-parameter';

export interface IPropertySmartSearchParameter { 
}
export class PropertySmartSearchParameter extends GenericBaseParameter<IPropertySmartSearchParameter> implements IPropertySmartSearchParameter { }